import { Flex, Text } from "@chakra-ui/react";
import { Avatar } from "../../components/user/Avatar";
import { useMobileBreakpoint } from "../../utils/useBreakpoints";

export function Creators() {
  const isMobileBreakpoint = useMobileBreakpoint();
  return (
    <Flex
      padding={isMobileBreakpoint ? "32px 24px" : "56px 40px"}
      flexDirection="column"
      gap="56px"
      background="charcoal.700"
      borderRadius="24px"
      width="100%"
    >
      <Text
        textAlign="center"
        color="dune.dune"
        fontSize="32px"
        fontFamily="Bricolage Grotesque"
        lineHeight="40px"
        fontWeight="500"
        letterSpacing="-.32px"
        width="100%"
      >
        The talented creators behind{" "}
        <span style={{ transform: "skew(-12deg)", display: "inline-block" }}>
          Apollyon
        </span>
        :
      </Text>
      <Flex
        width="100%"
        flexDirection="column"
        gap="32px"
        justifyContent="center"
        alignItems="center"
      >
        <Flex
          gap="18px"
          justifyContent="center"
          flexWrap="wrap"
          width="100%"
          maxWidth="670px"
        >
          <Creator
            role="Story"
            name="Valkyrae"
            imageSrc={"/static/images/web-ui/valkyrae/creators/valkyrae.jpg"}
          />
          <Creator
            role="Story / Writer"
            name="Brandon Chen"
            imageSrc={"/static/images/web-ui/valkyrae/creators/brandonChen.jpg"}
          />
          <Creator
            role="Artist"
            name="Thirdphp"
            imageSrc={"/static/images/web-ui/valkyrae/creators/thirdphp.jpg"}
          />
          <Creator
            role="Background Artist"
            name="Jaimee De Los Santos"
            imageSrc={"/static/images/web-ui/valkyrae/creators/jamieeDe.jpg"}
          />
          <Creator
            role="Colorist"
            name="Chromatic Level Studio"
            imageSrc={"/static/images/web-ui/valkyrae/creators/chromatic.jpg"}
          />
          <Creator
            role="Cover Artist"
            name="Xinillus"
            imageSrc={"/static/images/web-ui/valkyrae/creators/xinilius.jpg"}
          />
          <Creator
            role="Editor"
            name="Will Graves"
            imageSrc={"/static/images/web-ui/valkyrae/creators/will_graves.jpg"}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

export function Creator({
  role,
  name,
  imageSrc,
}: {
  role: string;
  name: string;
  imageSrc: string;
}) {
  return (
    <Flex flexDirection="column" gap="12px" width="121px" alignItems="center">
      <Avatar
        size="xl"
        imageSrc={window.gc.global.assets_url + imageSrc}
        ringStroke="green"
        cursor="default"
      />
      <Flex flexDirection="column" alignItems="center">
        <Text
          fontFamily="Bricolage Grotesque 24pt"
          fontSize="14px"
          color="neutral.400"
          textAlign="center"
        >
          {role}
        </Text>
        <Text
          fontFamily="Bricolage Grotesque 24pt"
          fontSize="16px"
          color="neutral.200"
          textAlign="center"
        >
          {name}
        </Text>
      </Flex>
    </Flex>
  );
}
